/*
* @Author: zhangzhitao
* @Date: 2019-05-20 11:18:32
* @Des:平台菜单管理，根据交互稿重构
 * @Last Modified by: yuzhou.zhou
 * @Last Modified time: 2020-07-02 19:53:45
*/

<template>
  <h-page-container class="page-plan-container">
    <h-page-header :breadcrumb="breadcrumb" />
    <h-layout direction="vertical">
      <h-layout-header>
        <el-tabs
          v-model="activeTab"
          class="page-tabs"
        >
          <el-tab-pane
            :label="$t('management.menu.app_menu_tab')"
            name="app"
          />
          <el-tab-pane
            :label="$t('management.menu.config_menu_tab')"
            name="config"
          />
          <el-tab-pane
            :label="$t('management.menu.tool_nav_tab')"
            name="toolNav"
          />
          <el-tab-pane
            :label="$t('management.menu.personal_menu_tab')"
            name="personal"
            v-if="basicInfo.showPersonalPage"
          />
        </el-tabs>
      </h-layout-header>
      <section class="toolbar">
        <el-button icon="h-icon-update" type="link" @click="updateMenus">{{$t('management.menu.menu_update')}}</el-button>
      </section>
      <menus-wrap
        :menus="menus"
        :activeTab="activeTab"
        @refresh="_getMenus"
      ></menus-wrap>
    </h-layout>
  </h-page-container>
</template>

<script>
import menusWrap from './menu-wrap'
import API from 'api/api'

export default {
  name: 'menu-management',
  data () {
    return {
      breadcrumb: [],
      activeTab: 'app',
      menus: [],
      basicInfo: {
        showPersonalPage: false
      },
      systemMenus: null
    }
  },

  components: { menusWrap },

  mounted () {
    this._getMenus()
    API.common.basicInfo().then(res => {
      this.basicInfo = res.data || {
        showPersonalPage: false
      }
    })
    this.getSystemMenus()
  },

  methods: {
    // 全量同步
    updateMenus () {
      API.menu.listSync()
         .then(_=>{
           this.$message.success(this.$t('management.menu.menu_update_success'))
           this._getMenus()
         })
    },
    getSystemMenus () {
      API.menu
        .getConfigMenu()
        .then(res => {
          this.systemMenus = res.data
          this.seekMenuRoots('isecure_custom_menu_portal', true)
        })
    },
    seekMenuRoots (_value, flag) {
      let _key = 'menuId'
      if (flag) {
        this.breadcrumb = []
        _key = 'permissionCode'
      }
      const findMenu = (arr, value, key) => {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i][key] === value) {
            return arr[i]
          }
          if (arr[i].children && arr[i].children.length > 0) {
            let _res = findMenu(arr[i].children, value, key)
            if (_res) return _res
          }
        }
        return null
      }
      let menu = findMenu(this.systemMenus, _value, _key)
      if (menu) {
        this.breadcrumb.unshift(menu.name || '')
        if (menu.parentId !== 'menu_config') {
          this.seekMenuRoots(menu.parentId)
        } else {
          this.breadcrumb.unshift(this.$t('common.sys_config'))
        }
      }
    },
    _getMenus () {
      if (this.activeTab === 'toolNav') {
        API.menu.toolBarList({
          type: this.activeTab
        }).then(res => {
          this.menus = []
          res.data.forEach(menu => {
            if (menu.name !== '-') {
              menu['iconInfo'] = {
                fileId: menu.icon || '-1',
                path: menu.iconPath || ''
              }
              this.menus.push(menu)
            }
          })
        })
      } else {
        API.menu.list({
          type: this.activeTab
        }).then(res => {
          this.menus = []
          res.data.forEach(menu => {
            if (menu.name !== '-') {
              this.menus.push(menu)
            }
          })
        })
      }
    }
  },
  watch: {
    activeTab () {
      this._getMenus()
    }
  }
}

</script>

<style lang="less" scoped>
.toolbar{
  position: absolute;
  right: 10px;
  top: 44px;
  z-index:8;
}
</style>
